import { render } from "./MapSideLegend.vue?vue&type=template&id=46322be2&scoped=true&ts=true&lang=pug"
import script from "./MapSideLegend.vue?vue&type=script&lang=ts&setup=true"
export * from "./MapSideLegend.vue?vue&type=script&lang=ts&setup=true"

import "./MapSideLegend.vue?vue&type=style&index=0&id=46322be2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46322be2"]])

export default __exports__